<template>
  <div class="flex items-center">
    <star-rating class="mr-1" :class="starClasses" v-for="(unit, index) in units" :key="index" :value="unit">
      />
    </star-rating>
  </div>
</template>

<script>
import StarRating from "@/component-library/star-rating"

const MAX_MARK = 5

const getUnits = (mark) => {
  const units = []
  for (let i = 0; i < MAX_MARK; i++) {
    if (Math.floor(mark) > i) {
      units[i] = 1
    } else if (Math.ceil(mark) <= i) {
      units[i] = 0
    } else {
      units[i] = parseFloat((mark - i).toFixed(1))
    }
  }
  return units
}

export default {
  name: "RatingStars",
  components: { StarRating },
  props: {
    starClasses: {
      type: String,
      default: "w-4 h-4"
    },
    mark: {
      type: Number,
      default: MAX_MARK,
      validator: (value) => value >= 0 && value <= MAX_MARK
    }
  },
  data() {
    return {
      units: getUnits(this.mark)
    }
  }
}
</script>
